import { prop } from '../../utilities';

export const cmsDomainSelector = state => state.cms || {};

const cmsSectionSelector = (state, sectionId: string) =>
  prop(state.cms, `sections.${sectionId}`, {});

export const sitemapSelector = (state, sectionId: string) =>
  prop(cmsSectionSelector(state, sectionId), 'sitemap', []);

export const sitemapByIdSelector = (state, sectionId: string) =>
  prop(cmsSectionSelector(state, sectionId), 'byId', {});

export const sitemapIsFetchingSelector = (state, sectionId: string) =>
  prop(cmsSectionSelector(state, sectionId), 'isFetching', false);

export const allArticlesSelector = (state, sectionId: string) =>
  prop(cmsSectionSelector(state, sectionId), 'allArticles', null);

export const articlesIsFetchingSelector = (state, sectionId: string) =>
  prop(cmsSectionSelector(state, sectionId), 'isFetchingArticles', true);

export const sectionMetaSelector = (state, sectionId: string) =>
  prop(cmsSectionSelector(state, sectionId), 'sectionMeta', null);
